import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

const CTASection = () => {
  return (
    <section className="container mx-auto py-16">
      <div className="flex flex-col md:flex-row items-center justify-center gap-12 max-w-7xl mx-auto">
        <div className="flex-1 max-w-[450px] bg-secondary/20 rounded-lg p-8 animate-fadeIn">
          <h2 className="font-serif font-bold text-4xl mb-6 text-left">Ready to Set Sail?</h2>
          <div className="text-left">
            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              Join our Discord community - whether you're looking to hang out, play some random battles
              with new friends, or explore joining one of our clans. At The Flying Dutchman, everyone is welcome
              to be part of our maritime adventure!
            </p>
            <Button
              className="bg-sunset hover:bg-sunset/80 text-navy font-semibold py-6 px-8 text-lg shadow-lg hover:shadow-sunset/20 transition-all duration-300"
              onClick={() => window.open("https://discord.gg/29gn3mXqtA", "_blank")}
            >
              <MessageSquare className="w-5 h-5 mr-2" />
              Join our Discord
            </Button>
          </div>
        </div>
        <div className="flex-1 w-full max-w-[350px] bg-secondary/20 rounded-lg p-2 animate-fadeIn">
          <iframe 
            src="https://discord.com/widget?id=364784581246713856&theme=dark" 
            width="100%" 
            height="500" 
            allowTransparency={true} 
            frameBorder="0" 
            sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
            className="rounded-lg"
            title="TFD Discord Widget"
          />
        </div>
      </div>
    </section>
  );
};

export default CTASection;